export default __webpack_public_path__ + "static/media/m2_logo.68680f1a.svg";